import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginLayout from './Layout/LoginLayout';
import Login from './Page/login';
import List from './Page/List'
import Dashboard from './Page/Dashboard'
import AddCompany from './Page/Company/AddCompany';
import EditCompany from './Page/Company/EditCompany';
import { getToken } from './utils'

function App() {

  const [hasToken, setHasToken] = useState(getToken())


  useEffect(() => {
    console.log('uhj');
    // if (localStorage.getItem('access_token') != null) {
    setHasToken(true)
    // }
  }, [hasToken])


  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        {hasToken &&
          <Route path='/dashboard' element={<Dashboard />}>
            <Route index element={<List />} />
            <Route path='AddCompany' element={<AddCompany />} />
            <Route path="EditCompany/:id" element={<EditCompany />} />
          </Route>
        }
      </Routes>
    </div>
  );
}

export default App;
